import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import dashboardlistService from "./dashboardService";
import vcdashboardService from "../vc-dashboard/vcdashboardservice";

// Get Attendance Report SLice Code  ------
export const getattendancereportlist = createAsyncThunk(
  "attendancereportlist/get-attendancereportlist",
  async (thunkAPI) => {
    try {
      return await dashboardlistService.getAttendanceReportList();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
// Get Vacant Report SLice Code  ------
export const getvacantreportlist = createAsyncThunk(
  "getvacantreportlist/get-getvacantreportlist",
  async (thunkAPI) => {
    try {
      return await dashboardlistService.getVacantReportlist();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
// Get Guest Lecture Report SLice Code  ------
export const getGuestLecturereportlist = createAsyncThunk(
  "getGuestLecturereportlist/get-GuestLecturereportlist",
  async (thunkAPI) => {
    try {
      return await dashboardlistService.getGuestLectureReportlist();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Get Industrial Visit Report SLice Code  ------
export const getIndustrialVisitreportlist = createAsyncThunk(
  "getIndustrialVisitreportlist/get-IndustrialVisitreportlist",
  async (thunkAPI) => {
    try {
      return await dashboardlistService.getIndustrialVisitReportlist();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Get Pending Invoice Report SLice Code  ------
export const getInvoicereportlist = createAsyncThunk(
  "getInvoicereportlist/get-Invoicereportlist",
  async (thunkAPI) => {
    try {
      return await dashboardlistService.getPendingInvoiceReportlist();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Get MOU Expire Report SLice Code  ------
export const getMoureportlist = createAsyncThunk(
  "getMoureportlist/get-Moureportlist",
  async (thunkAPI) => {
    try {
      return await dashboardlistService.getMouReportlist();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
// Get MOU Expire Report SLice Code  ------
export const getImportantUpdates = createAsyncThunk(
  "getImportantUpdates/get-ImportantUpdates",
  async (thunkAPI) => {
    try {
      return await dashboardlistService.getImportantUpdatelist();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Get Curriculam Progess Data ---------------
export const getCurriculamProgress = createAsyncThunk(
  "getCurriculamProgress/get-CurriculamProgress",
  async (thunkAPI) => {
    try {
      return await dashboardlistService.getCurriculamProgresslist();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getSalaryReport = createAsyncThunk(
  "getSalaryReport/get-SalaryReport",
  async (thunkAPI) => {
    try {
      return await dashboardlistService.getSalaryReportlist();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getWeeklyVcReviewList = createAsyncThunk(
  "weeklyVcReviewList/get-weeklyVcReviewList",
  async (thunkAPI) => {
    try {
      return await vcdashboardService.getWeeklyVcReviewList();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_all");

const initialState = {
  attendancereportlists: [],
  vacantreportlists: [],
  guestlecturereportlists: [],
  industrialvisitreportlists: [],
  invoicereportlists: [],
  moureportlists: [],
  importantupdatelists: [],
  CurriculamProgresslist: [],
  SalaryReportlist: [],
  getWeeklyVcReviewLists:[],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getattendancereportlist.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getattendancereportlist.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.attendancereportlists = action.payload;
      })
      .addCase(getattendancereportlist.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getvacantreportlist.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getvacantreportlist.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.vacantreportlists = action.payload;
      })
      .addCase(getvacantreportlist.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getGuestLecturereportlist.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getGuestLecturereportlist.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.guestlecturereportlists = action.payload;
      })
      .addCase(getGuestLecturereportlist.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getIndustrialVisitreportlist.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getIndustrialVisitreportlist.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.industrialvisitreportlists = action.payload;
      })
      .addCase(getIndustrialVisitreportlist.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getInvoicereportlist.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getInvoicereportlist.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.invoicereportlists = action.payload;
      })
      .addCase(getInvoicereportlist.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getMoureportlist.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMoureportlist.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.moureportlists = action.payload;
      })
      .addCase(getMoureportlist.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getImportantUpdates.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getImportantUpdates.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.importantupdatelists = action.payload;
      })
      .addCase(getImportantUpdates.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getCurriculamProgress.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCurriculamProgress.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.CurriculamProgresslist = action.payload;
      })
      .addCase(getCurriculamProgress.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getSalaryReport.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSalaryReport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.SalaryReportlist = action.payload;
      })
      .addCase(getSalaryReport.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getWeeklyVcReviewList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getWeeklyVcReviewList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.getWeeklyVcReviewLists = action.payload;
      })
      .addCase(getWeeklyVcReviewList.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })

      .addCase(resetState, () => initialState);
  },
});

export default dashboardSlice.reducer;
